/**
 * Classic ICOM Palette — editorial museum portal (light default)
 */

import { ThemeColors } from '../../assets/theme';

export const classicLight: ThemeColors = {
  primary: '#0A4F8A',
  primaryLight: '#1A6BC7',
  primaryDark: '#083E6D',

  secondary: '#4A90E2',
  secondaryLight: '#6BA3E8',
  secondaryDark: '#357ABD',

  accent: '#A27F45',
  accentLight: '#B8945C',
  accentDark: '#8A6B38',

  background: '#F5F3EE',
  surface: '#FFFFFF',
  surfaceHover: '#EFEEE9',

  text: '#1B2430',
  textSecondary: '#5F6874',
  textMuted: '#8A929E',

  success: '#1E6A42',
  warning: '#765512',
  error: '#962F2F',
  info: '#0A4F8A',
  successBg: '#E8F4EC',
  warningBg: '#FAF1D5',
  errorBg: '#FAE8E8',

  border: '#DDD8CE',
  borderLight: '#EBE7DF',
  divider: '#DDD8CE',

  shadow: 'rgba(20, 32, 44, 0.06)',
  shadowHover: 'rgba(20, 32, 44, 0.1)',
  shadowDark: 'rgba(20, 32, 44, 0.14)',

  overlay: 'rgba(27, 36, 48, 0.5)',
  overlayLight: 'rgba(10, 79, 138, 0.08)',

  gradientPrimary: 'linear-gradient(135deg, #0A4F8A 0%, #083E6D 100%)',
  gradientSecondary: 'linear-gradient(135deg, #4A90E2 0%, #6BA3E8 100%)',
  gradientBackground: '#F5F3EE',

  glass: 'rgba(255, 255, 255, 0.85)',
  glassBorder: 'rgba(221, 216, 206, 0.6)',
  glassShadow: '0 8px 24px rgba(20, 32, 44, 0.06)',

  icomBlue: '#0A4F8A',
  icomGold: '#A27F45',
  icomNavy: '#1B2430',
  icomLightBlue: '#E8F0F8',
  icomWarmGray: '#EFEEE9',
};

export const classicDark: ThemeColors = {
  primary: '#79B7E8',
  primaryLight: '#9ACAF0',
  primaryDark: '#5A9FD4',

  secondary: '#4A90E2',
  secondaryLight: '#6BA3E8',
  secondaryDark: '#357ABD',

  accent: '#C5A46D',
  accentLight: '#D4B88A',
  accentDark: '#A27F45',

  background: '#11161B',
  surface: '#1A2027',
  surfaceHover: '#222A33',

  text: '#F5F2EA',
  textSecondary: '#BAC2CC',
  textMuted: '#8A929E',

  success: '#4CAF50',
  warning: '#FFB300',
  error: '#EF5350',
  info: '#79B7E8',
  successBg: 'rgba(30, 106, 66, 0.2)',
  warningBg: 'rgba(118, 85, 18, 0.2)',
  errorBg: 'rgba(150, 47, 47, 0.2)',

  border: '#37414C',
  borderLight: '#2A323C',
  divider: '#37414C',

  shadow: 'rgba(0, 0, 0, 0.3)',
  shadowHover: 'rgba(0, 0, 0, 0.4)',
  shadowDark: 'rgba(0, 0, 0, 0.5)',

  overlay: 'rgba(0, 0, 0, 0.7)',
  overlayLight: 'rgba(121, 183, 232, 0.1)',

  gradientPrimary: 'linear-gradient(135deg, #79B7E8 0%, #5A9FD4 100%)',
  gradientSecondary: 'linear-gradient(135deg, #4A90E2 0%, #6BA3E8 100%)',
  gradientBackground: '#11161B',

  glass: 'rgba(26, 32, 39, 0.85)',
  glassBorder: 'rgba(55, 65, 76, 0.6)',
  glassShadow: '0 8px 24px rgba(0, 0, 0, 0.4)',

  icomBlue: '#79B7E8',
  icomGold: '#C5A46D',
  icomNavy: '#11161B',
  icomLightBlue: '#1E3A5F',
  icomWarmGray: '#222A33',
};
